import { render, staticRenderFns } from "./SpaceOverview.vue?vue&type=template&id=c50c894e&scoped=true"
import script from "./SpaceOverview.vue?vue&type=script&lang=js"
export * from "./SpaceOverview.vue?vue&type=script&lang=js"
import style0 from "./SpaceOverview.vue?vue&type=style&index=0&id=c50c894e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50c894e",
  null
  
)

export default component.exports